import { CustomButton } from '../../../features/customButton'
import { PROMO_CODE_TYPES } from '../../../../constants/tasksTypes'
import { useTranslation } from '../../../../translations'
import CustomBridge from '../../../../controllers/bridge/CustomBridge'

export default function TaskItemPromocodeButton({ quest }) {
  const { type, promocode } = quest

  const { t } = useTranslation()

  const isVisible = PROMO_CODE_TYPES.includes(type) && promocode

  const onClick = () => {
    navigator.clipboard.writeText(promocode).then(() => {
      CustomBridge.instance.send({
        name: 'SHOW_NOTIFICATION',
        type: 0,
        data: {
          hasCloseButton: false,
          text: t('other.promoCodeCopied'),
        },
      })
    })
  }

  return (
    isVisible && (
      <CustomButton
        className={
          'button_task task__item-button custom-button_challenge task__item-button_promocodeTask'
        }
        text={t('task.buttons.copy')}
        onClick={() => onClick()}
      />
    )
  )
}
